import "../../assets/css/index.css";
import React, { useState } from "react";
import swal from "sweetalert";
import Axios from "axios";
import Style from "../../assets/jsStyles/index";
import Info from "../Info";
import { isMobile } from "react-device-detect";
import EDCForm from "./edc15/EDCForm";
import MED9Form from "./med9/MED9";
import StripeContainer from "./StripeContainer";
// import FaqSection from "../../config/faq/FaqSection";
import Faq from "../../config/faq/Faq";
import FaqMed from "../../config/faq/faqMed";
import { ClipLoader } from "react-spinners"; // Import the react-spinner component

const config = require("../../config");
const { productsList } = require("../../config/products");

function Main(props) {
  const [formFlag, setFormFlag] = useState(true);
  const [productNumber, setProductNumber] = useState(0);
  const [conversionId, setConversionId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [downloadLink, setDownloadLink] = useState("");

  const products = productsList[props.productName];

  const setProduct = (id, number) => {
    setProductNumber(number);
    setConversionId(id);
    setFormFlag(false);
  };

  const setLoader = (flag) => {
    setLoading(flag);
  };

  const verifyAndDownload = (
    amount,
    orderId,
    address,
    paymentId,
    bypassCheck = false
  ) => {
    return new Promise((resolve, reject) => {
      const downloadApiPath = bypassCheck
        ? "/file/downloadAfter2Step"
        : "/file/verify";

      Axios.post(`${config.HOST}${downloadApiPath}`, {
        conversionId: conversionId,
        orderId: orderId,
        amount,
        address,
        ...(paymentId && { paymentId }),
      })
        .then((res) => {
          if (!res.data.actionRequired) {
            setDownloadLink(res.data.data);
            window.location = res.data.data;
          }
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
          swal({
            title: "Failed!",
            text: "Failed to complete payment! Please try again",
            icon: "failures",
            button: "Ok",
          });
          console.log(e);
        });
    });
  };

  return (
    <div className="App" id="app" style={{ fontFamily: "Roboto" }}>
      {loading && ( // Show the spinner when loading is true
        <div className="spinner">
          <ClipLoader size={50} color={"#ffffff"} loading={loading} />
        </div>
      )}
      <div
        className={isMobile ? "tg-mo" : "tg-container"}
        style={Style.infoAndFormDevider()}
      >
        <Info productName={props.productName} />
        <div
          className="formAndPayment"
          style={{
            width: "100%",
          }}
        >
          {config.ENV === "TEST" ? (
            <center>
              <h4 style={{ color: "red" }}>
                This is Test Environement<br></br>
                <a href="https://apps.tangentmotorsport.com">
                  Click here to go to actual app
                </a>
              </h4>
            </center>
          ) : null}
          {formFlag ? (
            props.productName === "edc15" ? (
              <>
                <EDCForm setProduct={setProduct} setLoader={setLoader} />
              </>
            ) : (
              <MED9Form setProduct={setProduct} setLoader={setLoader} />
            )
          ) : (
            <StripeContainer
              product={
                props.productName === "edc15"
                  ? products[productNumber - 1]
                  : products[productNumber]
              }
              verifyAndDownload={verifyAndDownload}
              setLoader={setLoader}
              downloadLink={downloadLink}
            />
          )}
        </div>
      </div>
      {props.productName === "edc15" ? <Faq /> : <FaqMed />}
    </div>
  );
}

export default Main;
